import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiHostUrl } from '../../util/const';
import { Quiz, QuizSubmission, QuestionBankItem } from '../../models/quiz.model';

@Injectable({
  providedIn: 'root',
})
export class QuizService {
  private http = inject(HttpClient);
  private baseUrl = getApiHostUrl() + '/api/v1/quizzes';
  private qbUrl = getApiHostUrl() + '/api/v1/question-bank';

  getQuizzesByLiveClass(liveClassId: string): Observable<Quiz[]> {
    return this.http.get<Quiz[]>(`${this.baseUrl}?liveClassId=${liveClassId}`);
  }

  getQuizById(quizId: string): Observable<Quiz> {
    return this.http.get<Quiz>(`${this.baseUrl}/${quizId}`);
  }

  createQuiz(quiz: Partial<Quiz>): Observable<Quiz> {
    return this.http.post<Quiz>(this.baseUrl, quiz);
  }

  updateQuiz(quizId: string, quiz: Partial<Quiz>): Observable<Quiz> {
    return this.http.put<Quiz>(`${this.baseUrl}/${quizId}`, quiz);
  }

  deleteQuiz(quizId: string): Observable<{ msg: string }> {
    return this.http.delete<{ msg: string }>(`${this.baseUrl}/${quizId}`);
  }

  submitQuiz(
    quizId: string,
    answers: { questionId: string; selectedOptionIds?: string[]; answerText?: string }[],
  ): Observable<QuizSubmission> {
    return this.http.post<QuizSubmission>(`${this.baseUrl}/${quizId}/submissions`, {
      answers,
    });
  }

  getSubmissionsForQuiz(quizId: string): Observable<QuizSubmission[]> {
    return this.http.get<QuizSubmission[]>(`${this.baseUrl}/${quizId}/submissions`);
  }

  getMySubmissions(quizId: string): Observable<QuizSubmission[]> {
    return this.http.get<QuizSubmission[]>(`${this.baseUrl}/${quizId}/my-submissions`);
  }

  // Question Bank
  getQuestionBank(): Observable<QuestionBankItem[]> {
    return this.http.get<QuestionBankItem[]>(this.qbUrl);
  }

  saveToQuestionBank(item: Partial<QuestionBankItem>): Observable<QuestionBankItem> {
    return this.http.post<QuestionBankItem>(this.qbUrl, item);
  }

  deleteFromQuestionBank(id: string): Observable<{ msg: string }> {
    return this.http.delete<{ msg: string }>(`${this.qbUrl}/${id}`);
  }
}
